import {
  EFetchModuleCapabilitiesAction,
  FetchModuleCapabilitiesAction,
} from "../actions/ModuleCapabilitiesActions";
import { FetchStatus } from "./../../Model/FetchStatus";
import { RootState } from "./RootReducer";
import { ModuleCapabilities } from "../../Model/Module";

type State = {
  status: FetchStatus;
  moduleCapabilitiesById: { [index: string]: ModuleCapabilities };
};

const initialState: State = {
  moduleCapabilitiesById: {},
  status: {
    pending: false,
    completed: false,
    error: null,
  },
};

function processModule(modules: ModuleCapabilities[]) {
  let moduleById: { [index: string]: ModuleCapabilities } = {};

  for (let module of modules) {
    moduleById[module.identifier] = module;
  }

  return moduleById;
}

export function modulesCapabilitiesReducer(
  state = initialState,
  action: FetchModuleCapabilitiesAction
): State {
  switch (action.type) {
    case EFetchModuleCapabilitiesAction.FETCH_MODULE_CAPABILITIES_PENDING:
      return {
        moduleCapabilitiesById: {},
        status: {
          pending: true,
          completed: false,
          error: null,
        },
      };
    case EFetchModuleCapabilitiesAction.FETCH_MODULE_CAPABILITIES_SUCCESS:
      if (action.moduleCapabilities == null) {
        throw new Error("Module Capabilities is null");
      }
      const processed = processModule(action.moduleCapabilities);
      return {
        moduleCapabilitiesById: processed,
        status: {
          pending: false,
          completed: true,
          error: null,
        },
      };
    case EFetchModuleCapabilitiesAction.FETCH_MODULE_CAPABILITIES_ERROR:
      return {
        moduleCapabilitiesById: {},
        status: {
          pending: false,
          completed: true,
          error: action.error,
        },
      };
    case EFetchModuleCapabilitiesAction.UPDATE_MODULE_CAPABILITIES:
      if (action.moduleCapabilities == null) {
        throw new Error("Module Capabilities is null");
      }
      const processedModuleCap = processModule(action.moduleCapabilities);
      return {
        moduleCapabilitiesById: processedModuleCap,
        status: {
          pending: false,
          completed: true,
          error: null,
        },
      };
    default:
      return state;
  }
}

export const getIsModuleHardwareDisconnected = (state:RootState): boolean => {
  return state.modulesCapabilitiesStore.moduleCapabilitiesById["Hardware"]?.isHardwareDisconnected
}

export const getModuleCapability = (
  state: RootState,
  moduleIdentifier: string
): ModuleCapabilities => {
  return state.modulesCapabilitiesStore.moduleCapabilitiesById[
    moduleIdentifier
  ];
};

export const getModuleCapabilitiesById = (
  state: RootState
): { [index: string]: ModuleCapabilities } => {
  return state.modulesCapabilitiesStore.moduleCapabilitiesById;
};

export const getModuleCapabilitiesFetchStatus = (
  state: RootState
): FetchStatus => state.modulesCapabilitiesStore.status;
